import angular from 'angular';

export class DeviceCheckListController {
  /*@ngInject*/
  constructor() {
    this.selectedList = this.selectedList || [];
  }

  $onInit() {
  }

  $onChanges() {
    if(!this.deviceList) { return; }
    this.allIds = this.deviceList.map(device => {
      return device.id;
    });
  }

  toggleCheck(id) {
    let index = this.selectedList.indexOf(id);

    if(index === -1) {
      this.selectedList.push(id);
    } else {
      this.selectedList.splice(index, 1);
    }

    this.changeSelectedList();
  }

  toggleAllCheck() {
    if(this.selectedList.length === this.allIds.length) {
      this.selectedList = [];
    } else {
      angular.copy(this.allIds, this.selectedList);
    }
  }

  changeSelectedList() {
    if (this.updateParam) {
      this.updateParam();
    }
  }
}

export default angular.module('leptonApp.deviceCheckList', [])
  .component('deviceCheckList', {
    template: require('./device-check-list.html'),
    controller: DeviceCheckListController,
    bindings: {
      deviceList: '<',
      selectedList: '=',
      disableAll: '=',
      updateParam: '&'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/device-check-list/device-check-list.component.js